import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { Visibility as ViewIcon, Edit as EditIcon, MoreVert as MoreIcon } from '@mui/icons-material';

interface ActionButtonsProps {
  onView?: () => void;
  onEdit?: () => void;
  onMore?: () => void;
  customActions?: Array<{
    icon: React.ReactNode;
    tooltip: string;
    onClick: () => void;
  }>;
  size?: 'small' | 'medium';
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  onView,
  onEdit,
  onMore,
  customActions = [],
  size = 'small'
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 1.5 }}>
      {onView && (
        <Tooltip title="Vezi">
          <IconButton size={size} onClick={onView}>
            <ViewIcon />
          </IconButton>
        </Tooltip>
      )}
      
      {onEdit && (
        <Tooltip title="Editeaza">
          <IconButton size={size} onClick={onEdit}>
            <EditIcon />
          </IconButton>
        </Tooltip>
      )}
      
      {customActions.map((action, index) => (
        <Tooltip key={index} title={action.tooltip}>
          <IconButton size={size} onClick={action.onClick}>
            {action.icon}
          </IconButton>
        </Tooltip>
      ))}
      
      {onMore && (
        <Tooltip title="Mai multe">
          <IconButton size={size} onClick={onMore}>
            <MoreIcon />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

export default ActionButtons;
